import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import { formateDate } from '@/utils/utils';
import fromDatasource from './datatest.js';
import draggable from 'vuedraggable';
import fieldstruct from '@/components/form/fieldstruct';
import selectconditions from '@/components/form/selectconditions';
export default {
  name: 'datasource',
  components: {
    draggable,
    fieldstruct,
    selectconditions
  },
  meta: {
    title: ''
  },
  data() {
    return {
      activeName: 'first',
      defaultformList: [],
      searchform: '',
      paramsArr: [],
      checkList: [],
      appform: {
        page: 1,
        limit: 20
      },
      listcondition: [],
      listrowname: [],
      listcoordinate: {},
      selectlistcondition: [],
      selectlistrowname: [],
      coordinateParams: [],
      selectlistcoordinate: [],
      activeNames: ['1'],
      flag1: false,
      listselectconditions: []
    };
  },
  created() {},
  watch: {},
  computed: {
    formList() {
      return this.defaultformList.filter(data => !this.searchform || data.name.toLowerCase().includes(this.searchform.toLowerCase()));
    }
  },
  mounted() {
    this.defaultformList = fromDatasource.dataList.map(item => {
      item.inserttime = formateDate(new Date(Number(item.inserttime)), 'yyyy-MM-dd hh:mm');
      item.updatetime = formateDate(new Date(Number(item.updatetime)), 'yyyy-MM-dd hh:mm');
      return item;
    });
    this.getformList();
  },
  methods: {
    getformList() {
      this.$api.getALLappList(this.$route.query.fid, this.appform).then(res => {
        console.log(res);
      });
    },
    tabshandleClick() {},
    selectformHandle(val) {
      this.paramsArr = [];
      this.$api.formStruct({
        deptId: this.$route.query.fid,
        formId: val.appName
      }).then(res => {
        res.forEach(elem => {
          this.paramsArr.push(elem);
          if (elem.compt === 'location') this.coordinateParams.push(elem);
        });
      });
    },
    selectChange(val, name) {
      if (!Array.isArray(val)) {
        this[`${name}`] = this.paramsArr.find(item => {
          return item.alias === val;
        });
        return;
      }
      this[`${name}`] = [];
      val.forEach((elem, index) => {
        this.paramsArr.forEach((item, index) => {
          if (elem === item.alias) {
            let newItem = {
              ...item
            };
            newItem.id = index;
            this[`${name}`].push(newItem);
          }
        });
      });
    },
    handleChange(val) {
      console.log(val);
      this.flag1 = val === '' ? false : true;
    },
    onStart(val) {
      console.log(val);
    },
    onEnd(val) {
      console.log(val);
      console.log(`listrowname`, this.listrowname);
    }
  }
};